import { Button, Grid, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import PopupText from '../common/PopupText';
import PopupTextField from '../common/PopupTextField';
import PopupDropDown from '../common/PopupDropDown';
import { getAuthClientDetails, getAuthClientList, showProgress } from '../../redux/actions/DealershipActions';
import Theme from '../ui/Theme';
import service from '../../apis/service';
import { ErrorToast, decryptAESJSONData, encryptAESJSONData, notifySuccess } from '../utils/Utils';
import Modal from '../common/Modal';
import { apiEndpoints } from '../../constants/apiEndpoints';

const ENCRYPT_DECRYPT_KEY = process.env.REACT_APP_ENCRYPT_REQUEST_KEY;

toast.configure();
const useStyles = makeStyles(() => ({
  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    fontStyle: 'normal',
  },
  popSubmitBtn: {
    padding: '0 70px',
    height: '45px',
    width: '200px',
  },
  popCancelBtn: {
    padding: '0 70px',
    height: '45px',
    width: '200px',
    marginRight: '28px',
  },
  popupMainContainer: {
    marginTop: '10px',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
}));

const AuthAddNewPopup = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [data, setData] = useState({});

  const dropdownTypeList = [{ id: 1, title: 'OIDC' }];
  const authclientdetails = useSelector((state) => state.getAuthClientDetails.authclientdetails);
  const authclientId = useSelector((state) => state.getSelectedAuthClientID);
  useEffect(() => {
    if (props.edit === true) {
      setData(authclientdetails);
    }
  }, [authclientdetails]);
  const handleDataChange = ({ target }) => {
    setData({ ...data, [target.name]: target.value });
  };
  const editAuth = async (editData) => {
    const encryptedData = encryptAESJSONData(editData, ENCRYPT_DECRYPT_KEY);

    await service
      .put(apiEndpoints.AUTH_UPDATE_AUTHENTICATION.replace('AUTH_CLIENT_ID', authclientId), {
        data: encryptedData,
      })
      .then((res) => {
        const decryptedData = decryptAESJSONData(res, ENCRYPT_DECRYPT_KEY);

        props.close();
        notifySuccess('Updated Successfully');
        dispatch(getAuthClientDetails(decryptedData));
        dispatch(
          getAuthClientList('update', {
            id: authclientdetails.id,
            name: decryptedData.name,
          }),
        );

        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  };
  const addAuth = async (addData) => {
    const encryptedData = encryptAESJSONData(addData, ENCRYPT_DECRYPT_KEY);

    await service
      .post(apiEndpoints.AUTH_APP_AUTHENTICATION, {
        data: encryptedData,
      })
      .then((res) => {
        const decryptedData = decryptAESJSONData(res, ENCRYPT_DECRYPT_KEY);

        props.close();
        notifySuccess('Saved Successfully');
        dispatch(getAuthClientList('append', decryptedData));
        props.handleClick(res.id);
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  };

  const submitAuth = async () => {
    dispatch(showProgress(true));
    if (!data.serviceConfiguration) {
      delete data.serviceConfiguration;
    }
    if (props.edit === true) {
      delete data.id;
      if (data.scopes === '' || data.scopes === null) {
        delete data.scopes;
      }
      editAuth(data);
    } else {
      addAuth(data);
    }
  };

  return (
    <Modal isOpen height="35vh" width="850px">
      <Grid container>
        <Grid container direction="row">
          <Grid item xs={11}>
            <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start">
              <Grid item className={classes.popupHeading}>
                {props.edit === false ? 'Add Authentication' : 'Edit Authentication'}
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={1}>
            <CloseIcon className={classes.popupCloseBtn} onClick={props.close} />
          </Grid>
        </Grid>
        <Grid container direction="row" className={classes.popupMainContainer}>
          <Grid item xs={6}>
            <Grid container direction="column">
              <Grid item>
                <PopupText text="Auth Name" required />
              </Grid>
              <Grid item>
                <PopupTextField
                  name="name"
                  rows={1}
                  placeholder="Auth Name"
                  id="name_id"
                  height="45"
                  handleChange={handleDataChange}
                  value={data.name}
                />
              </Grid>
              <Grid item>
                <PopupText text="Enter Endpoint URL " required />
              </Grid>
              <Grid item>
                <PopupTextField
                  name="issuer"
                  rows={1}
                  placeholder="Endpoint URL"
                  id="issuer_id"
                  height="45"
                  handleChange={handleDataChange}
                  value={data.issuer}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container direction="column">
              <Grid item>
                <PopupText text="Auth Type" required />
              </Grid>
              <Grid item>
                <PopupDropDown
                  handleChange={handleDataChange}
                  value={data.type}
                  list={dropdownTypeList}
                  height="43px"
                  width="343px"
                  marginBottom="20px"
                  name="type"
                />
              </Grid>
              <Grid item>
                <PopupText text="Company Code" required />
              </Grid>
              <Grid item>
                <PopupTextField
                  name="companyCode"
                  rows={1}
                  placeholder="Company Code"
                  id="company_code_id"
                  height="45"
                  handleChange={handleDataChange}
                  value={data.companyCode}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container justifyContent="center" alignItems="center">
          <Button variant="contained" className={classes.popCancelBtn} onClick={props.close}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" className={classes.popSubmitBtn} onClick={submitAuth}>
            Save
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default AuthAddNewPopup;
